<template>
  <el-container v-loading="isLoading" class="Edit">
    <el-header class="Edit-header">
      <el-page-header @back="close" :content="title"></el-page-header>
    </el-header>
    <el-main class="Edit-main">
      <el-form :model="form" :rules="rules" ref="form" label-width="110px">
        <el-form-item label="ADX名称" prop="adxName" style="width: 500px">
          <el-input v-model="form.adxName"></el-input>
        </el-form-item>
        <el-form-item label="协议类型" prop="protocolType">
          <el-select v-model="form.protocolType">
            <el-option v-for="(item, index) in this.myOption.protocolType" :label="item.name" :value="item.id" :key="index"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="加密密钥" prop="encryptKey" style="width: 500px">
          <el-input v-model="form.encryptKey"></el-input>
        </el-form-item>
        <el-form-item label="校验密钥" prop="checkKey" style="width: 500px">
          <el-input v-model="form.checkKey"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark" style="width: 500px">
          <el-input type="textarea" v-model="form.remark" maxlength="200" show-word-limit></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('form')">提交</el-button>
          <el-button v-if="isModel!==2" @click="resetForm('form')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-main>
  </el-container>
</template>

<script>
export default {
  name: 'Edit',
  data () {
    let adxNameRule = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入ADX名称'))
      } else {
        if (value.length < 1 || value.length > 100) {
          callback(new Error('长度在 1 到 100 个字符'))
        } else {
          if (this.isModel !== 2 || this.oldName !== value) {
            let param = {
              adxName: value
            }
            if (this.isSspUser) {
              param.userId = this.form.userId
            }
            this.$axios({
              method: 'post',
              headers: {
                'Authorization': this.$store.state.user.token,
                'ModuleId': this.thisModule.id
              },
              url: this.myOption.requestUrl + this.thisModule.exists,
              data: this.qs.stringify(param)
            }).then((res) => {
              let code = res.data.code
              if (code === 200) {
                if (res.data.data.exists) {
                  callback(new Error('ADX名称已存在'))
                } else {
                  callback()
                }
              } else {
                this.myOption.abnormalCode(this, code)
              }
            }).catch((err) => {
              this.myOption.abnormalCode(this, err)
            })
          } else {
            callback()
          }
        }
      }
    }
    return {
      id: '',
      title: '',
      oldName: '',
      thisModule: {},
      isSspUser: this.$store.getters.isMediaOwner,
      isModel: this.$store.getters.isEditId,
      isLoading: false,
      form: {
        adxName: '',
        protocolType: '',
        encryptKey: '',
        checkKey: '',
        remark: ''
      },
      rules: {
        adxName: [
          { required: true, validator: adxNameRule, trigger: 'blur' }
        ],
        protocolType: [
          { required: true, message: '请选择协议类型', trigger: 'change' }
        ],
        encryptKey: [
          { required: true, message: '请输入加密密钥', trigger: 'blur' }
        ],
        checkKey: [
          { required: true, message: '请输入校验密钥', trigger: 'blur' }
        ],
        remark: [
          { required: false, message: '请输入备注', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    let thisModule = this.myOption.requestModule.adx.children
    if (this.isModel === 2) {
      this.isLoading = true
      this.id = this.$store.state.user.editId
      this.title = '修改ADX'
      this.thisModule = thisModule.modify
      this.thisModule.detail = thisModule.detail
      this.getDetail()
    } else {
      this.title = '新建ADX'
      this.thisModule = thisModule.add
      if (this.isModel === 3) {
        this.isLoading = true
        this.id = this.$store.state.user.editId
        this.thisModule.detail = thisModule.detail
        this.getDetail()
      }
    }
  },
  methods: {
    close () {
      this.myOption.switchListAndEdit(this, true)
    },
    // 获取详情信息
    getDetail () {
      this.$axios({
        method: 'post',
        headers: {
          'Authorization': this.$store.state.user.token,
          'ModuleId': this.thisModule.detail.id
        },
        url: this.myOption.requestUrl + this.thisModule.detail.api,
        data: this.qs.stringify({
          adxId: this.id
        })
      }).then((res) => {
        let code = res.data.code
        if (code === 200) {
          let data = res.data.data
          this.form.adxName = data.adxName
          this.oldName = data.adxName
          this.form.protocolType = data.protocolType
          this.form.encryptKey = data.encryptKey
          this.form.checkKey = data.checkKey
          this.form.remark = data.remark
          this.isLoading = false
        } else {
          this.myOption.abnormalCode(this, code)
          this.isLoading = false
        }
      }).catch((err) => {
        this.myOption.abnormalCode(this, err)
        this.isLoading = false
      })
    },
    // 提交表单
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isLoading = true
          let param = {
            adxName: this.form.adxName,
            remark: this.form.remark,
            protocolType: this.form.protocolType,
            encryptKey: this.form.encryptKey,
            checkKey: this.form.checkKey
          }
          if (this.isModel === 2) {
            param.adxId = this.id
          }
          this.$axios({
            method: 'post',
            headers: {
              'Authorization': this.$store.state.user.token,
              'ModuleId': this.thisModule.id
            },
            url: this.myOption.requestUrl + this.thisModule.api,
            data: this.qs.stringify(param)
          }).then((res) => {
            let code = res.data.code
            this.isLoading = false
            if (code === 200) {
              this.$message.success(`${this.isModel === 2 ? '修改' : '新建'}ADX成功`)
              this.$router.push({path: this.$route.path.replace('/edit', '/list')})
            } else {
              this.myOption.abnormalCode(this, code)
            }
          }).catch((err) => {
            this.isLoading = false
            this.myOption.abnormalCode(this, err)
          })
        } else {
          return false
        }
      })
    },
    // 重置表单
    resetForm (formName) {
      this.$refs[formName].resetFields()
    }
  },
  beforeDestroy () {
    this.$store.dispatch('SetEditId', false)
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/adx/Edit.vue